import { createAction } from '@reduxjs/toolkit';
import type { AppLoadedPayload } from './interfaces';

const appStatedLoaded = createAction<AppLoadedPayload>('app-state:loaded');

export const sharedActions = {
  appStatedLoaded,
};